<template>
  <md-table v-model="sites" class="table-striped" table-header-color="primary">
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">
        <div v-if="item.stateId < 3">
          <span v-if="item.stateId === 2">
            <Badge :type="state(item.stateId).colour">{{
              state(item.stateId).name
            }}</Badge></span
          >
          &nbsp;
          <router-link :to="{ name: 'Site', params: { siteId: item.id } }">
            {{ item.name }} </router-link
          >&nbsp;&nbsp;<span v-if="item.archiveMessage"
            ><strong>Reason:</strong> {{ item.archiveMessage }}</span
          >
        </div>
        <div v-if="item.stateId === 3">
          <Badge :type="state(item.stateId).colour">{{
            state(item.stateId).name
          }}</Badge>
          &nbsp;
          {{ item.name }}
        </div>
      </md-table-cell>
      <md-table-cell class="text-right">
        <state-button
          type="Reactivate"
          :role="4"
          :stateId="item.stateId"
          :canRestore="item.canRestore"
          @state-click="reactivateSite(item.id)"
        ></state-button>
        <edit-button
          :stateId="item.stateId"
          :isSmall="true"
          @edit-click="editSite(item.id)"
        ></edit-button
        >&nbsp;
        <state-button
          tooltip="Delete Site"
          type="Delete"
          :stateId="item.stateId"
          :canDelete="item.canDelete"
          @state-click="deleteSite(item.id)"
        ></state-button>
        <state-button
          tooltip="Archive Site"
          type="Archive"
          :stateId="item.stateId"
          :canDelete="item.canDelete"
          @state-click="archiveSite(item.id)"
        ></state-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Sites Found"> </md-table-empty-state>
  </md-table>
</template>

<script>
import Swal from "sweetalert2";
import $ from "jquery";
import { Badge } from "@/components";
import { mapGetters } from "vuex";

export default {
  name: "SiteList",
  components: {
    Badge
  },
  computed: {
    ...mapGetters({
      sites: "data-management-client/sites",
      state: "state"
    })
  },
  methods: {
    async getSiteListing() {
      this.$store.dispatch(
        "data-management-client/getSiteListing",
        this.$route.params.clientId
      );
    },
    editSite(id) {
      this.$router.push({
        name: "Edit Site",
        params: { siteId: id }
      });
    },
    deleteSite(siteId) {
      Swal.fire({
        text: `Are you sure you want to delete this?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/deleteSite", siteId)
            .then(() => {
              this.getSiteListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    archiveSite(siteId) {
      Swal.fire({
        title: "Archive site?",
        html: `<div class="md-field md-theme-default"><span>Message:&nbsp;</span><br/>
            <input type="text" id="md-input" class="md-input">
            </div>`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        confirmButtonText: "Yes, archive it!",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/archiveSite", {
              id: siteId,
              message: $("#md-input").val()
            })
            .then(() => {
              this.getSiteListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data.errors.Message[0],
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    reactivateSite(siteId) {
      this.$store
        .dispatch("data-management-client/reactivateSite", siteId)
        .then(() => {
          this.getSiteListing();
        })
        .catch(error => {
          this.$notify({
            message: error.response.data,
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>

<style></style>
